import { useState, useCallback } from 'react';

type ModalType =
  | 'rosarySelection'
  | 'chapletSelection'
  | 'novenaSelection'
  | 'novenaModal'
  | 'prayerModal'
  | 'paywall'
  | 'welcome'
  | '54DayNovenaInfo'
  | 'novenaInfo'
  | 'rosaryInfo'
  | 'chapletInfo'
  | 'settings'
  | 'notifications'
  | 'debugPanel'
  | 'signIn';

interface ModalState {
  activeModal: ModalType | null;
  modalData?: any;
}

export const useModalManager = () => {
  const [modalState, setModalState] = useState<ModalState>({
    activeModal: null,
    modalData: undefined
  });

  const openModal = useCallback((modal: ModalType, data?: any) => {
    setModalState({
      activeModal: modal,
      modalData: data
    });
  }, []);

  const closeModal = useCallback(() => {
    setModalState({
      activeModal: null,
      modalData: undefined
    });
  }, []);

  const isModalOpen = useCallback((modal: ModalType) => {
    return modalState.activeModal === modal;
  }, [modalState.activeModal]);

  const isAnyModalOpen = useCallback(() => {
    return modalState.activeModal !== null;
  }, [modalState.activeModal]);

  return {
    activeModal: modalState.activeModal,
    modalData: modalState.modalData,
    openModal,
    closeModal,
    isModalOpen,
    isAnyModalOpen
  };
};